import React from 'react';
import styled from 'styled-components';
import {SubpageTitle} from "../Kit/Kit";

const Container = styled.div`
  height: 40vw;
  background: ${props => props.bg ? `url(${props.bg})` : '' } bottom no-repeat;
  display: flex;
  align-items: center;  
  justify-content: center;
  margin-top: 60px;
  
  @media(min-width: 500px) {
    height: 30vw;
  }
  
  @media(min-width: 768px){
    height: 20vw;
    margin-top: 75px;
  }
 
   @media (min-width: 992px) {
     margin-top: 85px;
   }
 
   @media(min-width: 1200px){
     margin-top: 95px;
   }
  
  h1 {
    padding: 0 10px;
    text-transform: capitalize;
  }
`;

const Header = (props) => {
    return (
      <Container bg={props.bg}>
          <SubpageTitle>{props.title}</SubpageTitle>
      </Container>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js